import { render, staticRenderFns } from "./OwalList.vue?vue&type=template&id=0537a76d&scoped=true"
import script from "./OwalList.vue?vue&type=script&lang=js"
export * from "./OwalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537a76d",
  null
  
)

export default component.exports